// Sürükle-Bırak Soruları - Her ünite için 10+ soru
// Bu dosya cabinCrewContents.js'e import edilecek

export const dragDropQuestions = {
  // ===== MODÜL 1: Kabin Memurluğuna Giriş =====
  
  'CM-M1-DRAG-01': {
    lesson_id: 'CM-M1-DRAG-01',
    title: '🎮 Sırala: Görev Öncelikleri',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '📋 Kabin memurunun görevlerini ÖNEMLİ\'den DAHA AZ ÖNEMLİ\'ye sırala',
      items: [
        { text: '🛡️ Yolcu güvenliğini sağlamak', order: 1 },
        { text: '🚨 Acil durum prosedürlerini uygulamak', order: 2 },
        { text: '🏥 İlk yardım müdahalesi yapmak', order: 3 },
        { text: '🍽️ Yemek servisi yapmak', order: 4 },
        { text: '🛒 Duty free satışı yapmak', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-02': {
    lesson_id: 'CM-M1-DRAG-02',
    title: '🎮 Sırala: Kariyer Basamakları',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '📈 Kariyer basamaklarını BAŞLANGIÇ\'tan ZİRVE\'ye sırala',
      items: [
        { text: '👶 Junior Cabin Crew', order: 1 },
        { text: '👨‍✈️ Senior Cabin Crew', order: 2 },
        { text: '🎖️ Purser / Cabin Chief', order: 3 },
        { text: '👑 Cabin Manager', order: 4 },
        { text: '🌟 Ground Trainer', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-03': {
    lesson_id: 'CM-M1-DRAG-03',
    title: '🎮 Sırala: Uçuş Öncesi Hazırlık',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '⏰ Uçuş öncesi yapılması gerekenleri SIRASINA göre yerleştir',
      items: [
        { text: '📋 Briefing toplantısına katıl', order: 1 },
        { text: '✈️ Uçağı kontrol et', order: 2 },
        { text: '🧯 Acil durum ekipmanlarını kontrol et', order: 3 },
        { text: '🍽️ Catering malzemelerini kontrol et', order: 4 },
        { text: '👥 Yolcuları karşıla', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-04': {
    lesson_id: 'CM-M1-DRAG-04',
    title: '🎮 Sırala: Acil Durum Öncelikleri',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🚨 Acil durumda yapılması gerekenleri sırala',
      items: [
        { text: '📢 Pilotları bilgilendir', order: 1 },
        { text: '🧘 Sakin kal ve yolcuları sakinleştir', order: 2 },
        { text: '🔊 Anonsları yap', order: 3 },
        { text: '👥 Yolcuları yönlendir', order: 4 },
        { text: '🚪 Tahliye yap', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-05': {
    lesson_id: 'CM-M1-DRAG-05',
    title: '🎮 Sırala: Havayolu Türleri',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '💰 Havayolu türlerini FİYAT OLARAK en pahalıdan ucuza sırala',
      items: [
        { text: '👑 Premium/Luxury (Emirates, Qatar)', order: 1 },
        { text: '⭐ Full-Service (THY, Lufthansa)', order: 2 },
        { text: '🌐 Regional (SunExpress)', order: 3 },
        { text: '✈️ Low-Cost (Pegasus, Ryanair)', order: 4 },
        { text: '📦 Charter (Corendon)', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-06': {
    lesson_id: 'CM-M1-DRAG-06',
    title: '🎮 Sırala: Boarding Süreci',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🚪 Boarding sürecini doğru sıraya koy',
      items: [
        { text: '♿ Özel yardım gereken yolcular', order: 1 },
        { text: '👶 Bebekli aileler', order: 2 },
        { text: '💎 Business Class yolcular', order: 3 },
        { text: '🔙 Arka sıra yolcuları', order: 4 },
        { text: '🔜 Ön sıra yolcuları', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-07': {
    lesson_id: 'CM-M1-DRAG-07',
    title: '🎮 Sırala: Mülakat Hazırlığı',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '📝 Mülakat hazırlığı adımlarını sırala',
      items: [
        { text: '🔍 Havayolunu araştır', order: 1 },
        { text: '👔 Kıyafet ve görünüm hazırlığı', order: 2 },
        { text: '💬 Sık sorulan soruları çalış', order: 3 },
        { text: '🗣️ İngilizce pratiği yap', order: 4 },
        { text: '😴 Mülakat öncesi gece iyi uyu', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-08': {
    lesson_id: 'CM-M1-DRAG-08',
    title: '🎮 Sırala: Servis Sırası',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🍽️ Uçak içi servis sırasını belirle',
      items: [
        { text: '🍷 Hoş geldiniz içeceği', order: 1 },
        { text: '🥗 Ana yemek servisi', order: 2 },
        { text: '☕ İçecek servisi', order: 3 },
        { text: '🛒 Duty-Free satışı', order: 4 },
        { text: '🍬 İniş öncesi atıştırmalık', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-09': {
    lesson_id: 'CM-M1-DRAG-09',
    title: '🎮 Sırala: İniş Hazırlığı',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🛬 İniş hazırlığı adımlarını sırala',
      items: [
        { text: '📢 Koltuk kemeri anonsu', order: 1 },
        { text: '🪟 Pencereleri aç komutu', order: 2 },
        { text: '💺 Koltukları dik pozisyona al', order: 3 },
        { text: '🧳 Kabin kontrolü yap', order: 4 },
        { text: '🚪 Pozisyon al', order: 5 },
      ]
    }
  },
  
  'CM-M1-DRAG-10': {
    lesson_id: 'CM-M1-DRAG-10',
    title: '🎮 Sırala: Eğitim Süreci',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '📚 Kabin memuru eğitim sürecini sırala',
      items: [
        { text: '📝 Başvuru ve mülakat', order: 1 },
        { text: '🎓 Teorik eğitim (4-6 hafta)', order: 2 },
        { text: '✈️ Uçuş simülasyonu', order: 3 },
        { text: '🏥 İlk yardım sertifikası', order: 4 },
        { text: '🎖️ İlk uçuş (süpervizör eşliğinde)', order: 5 },
      ]
    }
  },

  // ===== MODÜL 2: Havacılık Terimleri =====
  
  'CM-M2-DRAG-01': {
    lesson_id: 'CM-M2-DRAG-01',
    title: '🎮 Sırala: NATO Alfabesi',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🔤 NATO alfabesinde A-E harflerini sırala',
      items: [
        { text: 'Alpha (A)', order: 1 },
        { text: 'Bravo (B)', order: 2 },
        { text: 'Charlie (C)', order: 3 },
        { text: 'Delta (D)', order: 4 },
        { text: 'Echo (E)', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-02': {
    lesson_id: 'CM-M2-DRAG-02',
    title: '🎮 Sırala: Uçak Bölümleri',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '✈️ Uçak bölümlerini ÖNDEN ARKAYA sırala',
      items: [
        { text: '🛫 Cockpit (Kokpit)', order: 1 },
        { text: '💎 First Class', order: 2 },
        { text: '⭐ Business Class', order: 3 },
        { text: '💺 Economy Class', order: 4 },
        { text: '🚪 Aft Galley (Arka Mutfak)', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-03': {
    lesson_id: 'CM-M2-DRAG-03',
    title: '🎮 Sırala: Uçuş Fazları',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🛫 Uçuş fazlarını sırala',
      items: [
        { text: '🚪 Boarding (Biniş)', order: 1 },
        { text: '🛫 Taxi & Take-off (Kalkış)', order: 2 },
        { text: '☁️ Cruise (Seyir)', order: 3 },
        { text: '⬇️ Descent (Alçalma)', order: 4 },
        { text: '🛬 Landing (İniş)', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-04': {
    lesson_id: 'CM-M2-DRAG-04',
    title: '🎮 Sırala: Zaman Dilimleri',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🌍 Şehirleri BATI\'dan DOĞU\'ya sırala (zaman dilimi)',
      items: [
        { text: '🗽 New York (UTC-5)', order: 1 },
        { text: '🇬🇧 Londra (UTC+0)', order: 2 },
        { text: '🇹🇷 İstanbul (UTC+3)', order: 3 },
        { text: '🇦🇪 Dubai (UTC+4)', order: 4 },
        { text: '🇯🇵 Tokyo (UTC+9)', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-05': {
    lesson_id: 'CM-M2-DRAG-05',
    title: '🎮 Sırala: Havacılık Kodları',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🏷️ Havalimanı kodlarını alfabetik sırala',
      items: [
        { text: 'AMS - Amsterdam', order: 1 },
        { text: 'CDG - Paris', order: 2 },
        { text: 'DXB - Dubai', order: 3 },
        { text: 'IST - İstanbul', order: 4 },
        { text: 'JFK - New York', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-06': {
    lesson_id: 'CM-M2-DRAG-06',
    title: '🎮 Sırala: Acil Durum Ekipmanları',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🧯 Acil durum ekipmanlarını KULLANIM SIKLIĞI\'na göre sırala',
      items: [
        { text: '🩹 İlk Yardım Çantası', order: 1 },
        { text: '🫁 Oksijen Maskesi', order: 2 },
        { text: '🦺 Can Yeleği', order: 3 },
        { text: '🧯 Yangın Söndürücü', order: 4 },
        { text: '🛟 Tahliye Kaydırağı', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-07': {
    lesson_id: 'CM-M2-DRAG-07',
    title: '🎮 Sırala: Hava Durumu Terimleri',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🌤️ Hava durumunu EN İYİ\'den EN KÖTÜ\'ye sırala',
      items: [
        { text: '☀️ CAVOK (Clear)', order: 1 },
        { text: '🌤️ Few Clouds', order: 2 },
        { text: '☁️ Overcast', order: 3 },
        { text: '🌧️ Rain', order: 4 },
        { text: '⛈️ Thunderstorm', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-08': {
    lesson_id: 'CM-M2-DRAG-08',
    title: '🎮 Sırala: Personel Hiyerarşisi',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '👥 Uçak personel hiyerarşisini sırala',
      items: [
        { text: '👨‍✈️ Captain (Kaptan)', order: 1 },
        { text: '👨‍✈️ First Officer (Yardımcı Pilot)', order: 2 },
        { text: '🎖️ Purser (Kabin Şefi)', order: 3 },
        { text: '👨‍✈️ Senior Cabin Crew', order: 4 },
        { text: '👶 Junior Cabin Crew', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-09': {
    lesson_id: 'CM-M2-DRAG-09',
    title: '🎮 Sırala: Türbülans Seviyeleri',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '💨 Türbülans seviyelerini HAFİF\'ten ŞİDDETLİ\'ye sırala',
      items: [
        { text: '😊 Light (Hafif)', order: 1 },
        { text: '😐 Moderate (Orta)', order: 2 },
        { text: '😟 Severe (Şiddetli)', order: 3 },
        { text: '😰 Extreme (Aşırı)', order: 4 },
        { text: '🚫 Flight Cancel (Uçuş İptal)', order: 5 },
      ]
    }
  },
  
  'CM-M2-DRAG-10': {
    lesson_id: 'CM-M2-DRAG-10',
    title: '🎮 Sırala: Uçak Kapıları',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🚪 Uçak kapılarını ÖNDEN ARKAYA sırala',
      items: [
        { text: '1L/1R - Ön Sol/Sağ Kapı', order: 1 },
        { text: '2L/2R - Kanat Üstü Kapı', order: 2 },
        { text: '3L/3R - Orta Kapı', order: 3 },
        { text: '4L/4R - Arka Kapı', order: 4 },
        { text: 'Aft - En Arka Kapı', order: 5 },
      ]
    }
  },

  // ===== MODÜL 3: Güvenlik Prosedürleri =====
  
  'CM-M3-DRAG-01': {
    lesson_id: 'CM-M3-DRAG-01',
    title: '🎮 Sırala: Yangın Müdahalesi',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '🔥 Yangın müdahale adımlarını sırala',
      items: [
        { text: '🔍 Yangını tespit et', order: 1 },
        { text: '📢 Pilotları bilgilendir', order: 2 },
        { text: '🧯 Yangın söndürücüyü al', order: 3 },
        { text: '💨 P.A.S.S. tekniği uygula', order: 4 },
        { text: '✅ Durumu raporla', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-02': {
    lesson_id: 'CM-M3-DRAG-02',
    title: '🎮 Sırala: Tahliye Prosedürü',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '🚨 Acil tahliye adımlarını sırala',
      items: [
        { text: '📢 "EVACUATE" komutu al', order: 1 },
        { text: '🚪 Kapı durumunu kontrol et', order: 2 },
        { text: '🛝 Slide\'ı aktive et', order: 3 },
        { text: '👥 Yolcuları yönlendir', order: 4 },
        { text: '🔍 Kabin kontrolü yap', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-03': {
    lesson_id: 'CM-M3-DRAG-03',
    title: '🎮 Sırala: CPR Adımları',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '🏥 CPR (Kalp Masajı) adımlarını sırala',
      items: [
        { text: '🔍 Bilinç kontrolü yap', order: 1 },
        { text: '📞 Yardım çağır', order: 2 },
        { text: '🫁 Solunum kontrolü', order: 3 },
        { text: '💓 30 göğüs basısı', order: 4 },
        { text: '💨 2 suni solunum', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-04': {
    lesson_id: 'CM-M3-DRAG-04',
    title: '🎮 Sırala: Decompression',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '🫁 Basınç kaybında yapılacakları sırala',
      items: [
        { text: '😷 Kendi maskeni tak', order: 1 },
        { text: '📢 Yolcuları bilgilendir', order: 2 },
        { text: '👥 Yolculara yardım et', order: 3 },
        { text: '💺 Oturarak bekle', order: 4 },
        { text: '📝 Raporla', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-05': {
    lesson_id: 'CM-M3-DRAG-05',
    title: '🎮 Sırala: Denize Düşme',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '🌊 Denize zorunlu inişte yapılacakları sırala',
      items: [
        { text: '🦺 Can yeleği giy', order: 1 },
        { text: '📢 Brace pozisyonu al', order: 2 },
        { text: '🚪 Su seviyesini bekle', order: 3 },
        { text: '🛟 Can salını şişir', order: 4 },
        { text: '👥 Tahliye et', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-06': {
    lesson_id: 'CM-M3-DRAG-06',
    title: '🎮 Sırala: Tıbbi Acil',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🏥 Tıbbi acil durumda yapılacakları sırala',
      items: [
        { text: '🔍 Durumu değerlendir', order: 1 },
        { text: '📢 Pilotu bilgilendir', order: 2 },
        { text: '🎤 Doktor anonsu yap', order: 3 },
        { text: '🩺 Tıbbi kit al', order: 4 },
        { text: '📝 Formu doldur', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-07': {
    lesson_id: 'CM-M3-DRAG-07',
    title: '🎮 Sırala: Güvenlik Denetimi',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🔒 Kalkış öncesi güvenlik kontrollerini sırala',
      items: [
        { text: '🚪 Kapılar kapalı ve kilitli', order: 1 },
        { text: '🧯 Acil ekipmanlar yerinde', order: 2 },
        { text: '💺 Kemerler takılı', order: 3 },
        { text: '🪟 Güneşlikler açık', order: 4 },
        { text: '💺 Koltuklar dik', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-08': {
    lesson_id: 'CM-M3-DRAG-08',
    title: '🎮 Sırala: Hijyen Prosedürleri',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🧼 Hijyen prosedürlerini önem sırasına koy',
      items: [
        { text: '🖐️ El yıkama/dezenfektan', order: 1 },
        { text: '😷 Maske takma', order: 2 },
        { text: '🧤 Eldiven kullanma', order: 3 },
        { text: '🗑️ Atık yönetimi', order: 4 },
        { text: '🧹 Yüzey temizliği', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-09': {
    lesson_id: 'CM-M3-DRAG-09',
    title: '🎮 Sırala: Zorba Yolcu',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '😠 Zorba yolcu yönetimi adımları',
      items: [
        { text: '🗣️ Sakin bir şekilde yaklaş', order: 1 },
        { text: '👂 Dinle ve anla', order: 2 },
        { text: '⚠️ Uyar (1. uyarı)', order: 3 },
        { text: '📢 Pilotu bilgilendir', order: 4 },
        { text: '👮 Gerekirse müdahale', order: 5 },
      ]
    }
  },
  
  'CM-M3-DRAG-10': {
    lesson_id: 'CM-M3-DRAG-10',
    title: '🎮 Sırala: Bomba Tehdidi',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '💣 Bomba tehdidi prosedürünü sırala',
      items: [
        { text: '📞 Tehdidi ciddi al', order: 1 },
        { text: '📝 Bilgi topla', order: 2 },
        { text: '👨‍✈️ Pilotu bilgilendir', order: 3 },
        { text: '🔍 Şüpheli paket ara', order: 4 },
        { text: '⚡ Prosedürleri uygula', order: 5 },
      ]
    }
  },

  // ===== MODÜL 4: Servis Prosedürleri =====
  
  'CM-M4-DRAG-01': {
    lesson_id: 'CM-M4-DRAG-01',
    title: '🎮 Sırala: Business Class Servisi',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '💎 Business class servis sırasını belirle',
      items: [
        { text: '🥂 Hoş geldiniz şampanyası', order: 1 },
        { text: '🧴 Sıcak havlu servisi', order: 2 },
        { text: '🍽️ Menü sunumu', order: 3 },
        { text: '🍷 Ana yemek servisi', order: 4 },
        { text: '☕ Kahve/çay ve tatlı', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-02': {
    lesson_id: 'CM-M4-DRAG-02',
    title: '🎮 Sırala: Trolley Hazırlığı',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🛒 Servis arabası hazırlık adımları',
      items: [
        { text: '✅ Stok kontrolü yap', order: 1 },
        { text: '🧊 Buz ve soğuk içecekleri koy', order: 2 },
        { text: '☕ Sıcak içecekleri hazırla', order: 3 },
        { text: '🍪 Atıştırmalıkları yerleştir', order: 4 },
        { text: '🧻 Peçete ve bardakları düzenle', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-03': {
    lesson_id: 'CM-M4-DRAG-03',
    title: '🎮 Sırala: Duty Free Satışı',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🛍️ Duty Free satış sürecini sırala',
      items: [
        { text: '📋 Katalog dağıt', order: 1 },
        { text: '🎤 Promosyonları duyur', order: 2 },
        { text: '🛒 Siparişleri al', order: 3 },
        { text: '💳 Ödeme al', order: 4 },
        { text: '📝 Satış formu doldur', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-04': {
    lesson_id: 'CM-M4-DRAG-04',
    title: '🎮 Sırala: Özel Yemek Servisi',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🍽️ Özel yemek (SPML) servis önceliği',
      items: [
        { text: '👶 Bebek yemeği', order: 1 },
        { text: '🏥 Diyabetik/Medikal', order: 2 },
        { text: '☪️ Halal/Kosher', order: 3 },
        { text: '🥗 Vejetaryen/Vegan', order: 4 },
        { text: '🍽️ Standart yemek', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-05': {
    lesson_id: 'CM-M4-DRAG-05',
    title: '🎮 Sırala: Şikayet Yönetimi',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '😤 Yolcu şikayeti yönetim adımları',
      items: [
        { text: '👂 Dinle ve empati kur', order: 1 },
        { text: '🙏 Özür dile', order: 2 },
        { text: '🔍 Sorunu anla', order: 3 },
        { text: '💡 Çözüm öner', order: 4 },
        { text: '✅ Takip et', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-06': {
    lesson_id: 'CM-M4-DRAG-06',
    title: '🎮 Sırala: İçecek Servisi',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🥤 İçecek servis sırası',
      items: [
        { text: '💎 Business/First Class', order: 1 },
        { text: '👶 Çocuklu aileler', order: 2 },
        { text: '🔜 Economy ön sıralar', order: 3 },
        { text: '🔙 Economy arka sıralar', order: 4 },
        { text: '🔄 İkinci tur', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-07': {
    lesson_id: 'CM-M4-DRAG-07',
    title: '🎮 Sırala: Galley Organizasyonu',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '🍳 Galley organizasyon öncelikleri',
      items: [
        { text: '🧊 Soğuk depolama', order: 1 },
        { text: '🔥 Sıcak yemek hazırlığı', order: 2 },
        { text: '🥤 İçecek düzeni', order: 3 },
        { text: '🗑️ Çöp yönetimi', order: 4 },
        { text: '🧹 Temizlik', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-08': {
    lesson_id: 'CM-M4-DRAG-08',
    title: '🎮 Sırala: VIP Yolcu Servisi',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: '👑 VIP yolcu hizmet protokolü',
      items: [
        { text: '🎤 Kaptan tarafından karşılama', order: 1 },
        { text: '🧳 Bagaj yardımı', order: 2 },
        { text: '💺 Koltuk ayarlama', order: 3 },
        { text: '🥂 Kişisel karşılama servisi', order: 4 },
        { text: '📞 Sürekli iletişim', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-09': {
    lesson_id: 'CM-M4-DRAG-09',
    title: '🎮 Sırala: Uçuş Sonu',
    type: 'dragdrop',
    duration: 3,
    xp: 35,
    dragdrop: {
      instruction: '✈️ Uçuş sonu görevleri',
      items: [
        { text: '👋 Yolcuları uğurla', order: 1 },
        { text: '🔍 Kabin kontrolü', order: 2 },
        { text: '📋 Raporları doldur', order: 3 },
        { text: '🗑️ Temizlik yardımı', order: 4 },
        { text: '📝 Debriefing', order: 5 },
      ]
    }
  },
  
  'CM-M4-DRAG-10': {
    lesson_id: 'CM-M4-DRAG-10',
    title: '🎮 Sırala: Transfer Yolcuları',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '🔄 Transfer yolcularına yardım sırası',
      items: [
        { text: '⏰ Kısa bağlantılı yolcular', order: 1 },
        { text: '♿ Tekerlekli sandalye', order: 2 },
        { text: '👶 Çocuklu aileler', order: 3 },
        { text: '🗣️ Dil problemi olanlar', order: 4 },
        { text: '✈️ Normal transfer', order: 5 },
      ]
    }
  }
};

// Ana içerik dosyasına eklenecek yardımcı fonksiyon
export const getDragDropByModule = (moduleNumber) => {
  const prefix = `CM-M${moduleNumber}-DRAG`;
  return Object.entries(dragDropQuestions)
    .filter(([key]) => key.startsWith(prefix))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};

export default dragDropQuestions;
